import Component from '@glimmer/component';

import { get } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { linkToAction } from 'ember-route-state/decorators/link-to-action.js';

import CButton from 'rise-ui/components/c-button.gjs';
import ReloadModel from 'rise-ui/components/reload-model.gjs';
import SearchFilterGroup from 'rise-ui/components/search-filter-group.gjs';
import classMod from 'rise-ui/helpers/class-mod.js';
import classModConfig from 'rise-ui/helpers/class-mod-config.js';
import fnx from 'rise-ui/helpers/fnx.js';
import nom from 'rise-ui/helpers/nom.js';
import set from 'rise-ui/helpers/set.js';
import { or } from 'rise-ui/utils/object/computed.js';
import { service } from '@ember/service';

@linkToAction
export default class SearchFiltersComponent extends Component {
  @service ssr;

  @or('args.filters.isPending', 'ssr.isSsr') isLoading;
  @or(
    'args.{action,onSelectionChange}',
    'args.config.{action,onSelectionChange}'
  ) selectionChangeHandler;
  // On selection change: callback with selection
  @action onFilter(filterKey, selection, ...args) {
    return this.callLinkToActionByName('selectionChangeHandler', filterKey, selection, ...args);
  }

  <template>
    {{#let (classModConfig "c-search-filters") as | classModConfig |}}
    <div class={{classMod "" this.showFilters "--visible" config=classModConfig}}>
      <h4 class={{classMod "" this.showFilters "--visible" config=classModConfig suffix="__label"}}
        {{on "click" (set this "showFilters" true)}}
      >
        {{~nom~}}
        <span class={{classMod "" config=classModConfig suffix="__label--desktop"}}>Filter By</span>
        {{~nom~}}
        <span class={{classMod "" config=classModConfig suffix="__label--mobile"}}>Filter</span>
        {{~nom~}}
      </h4>
      <div class={{classMod "" this.showFilters "--visible" config=classModConfig suffix="__body"}}>
        <h4 class={{classMod config=classModConfig suffix="__body-label"}}
          {{on "click" (set this "showFilters" false)}}
        >Filter By</h4>
        {{#if @filters.isRejected}}
          <div class="c-no-result {{classMod config=classModConfig suffix="__error"}}">
            Error fetching filters. <ReloadModel>Retry</ReloadModel>
          </div>
        {{else}}
          {{#each @filters.value as | filter |}}
            <SearchFilterGroup
              @groups={{filter.group}}
              @route={{@route}}
              @label={{filter.label}}
              @refresh={{@refresh}}
              @options={{filter.options}}
              @selection={{get @selection filter.key}}
              @action={{fnx this.onFilter filter.key}}
            />
          {{else}}
            {{#if this.isLoading}}
              <div class="
                c-no-result
                {{classMod config=classModConfig suffix="__init"}}
              ">Loading Filters...</div>
            {{else}}
              <div class="
                c-no-result
                {{classMod config=classModConfig suffix="__empty"}}
              ">No Filters</div>
            {{/if}}
          {{/each}}
        {{/if}}
        <div class={{classMod config=classModConfig suffix="__body-actions"}}>
          <CButton @action={{set this "showFilters" false}}>Close</CButton>
          {{#if @refresh}}
            <CButton
              @type="primary"
              @action={{set this "showFilters" false}}
              @linkTo={{@route}}
            >Show Results</CButton>
          {{/if}}
        </div>
      </div>
    </div>
    {{/let}}
  </template>
}
